import { Setting, Subscription } from '../App';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';
import { Dispatch, useEffect } from 'react';
import {PaymentMethodType} from "../types/payment-method-type";

export const usePaymentMethodUpdate = (setting: Setting, setSubscriptionContractId: Dispatch<string>, setPaymentMethod: Dispatch<PaymentMethodType>) => {
  useEffect(() => {
    (async () => {
      try {
        const subscriptionsResponse = await axios.post(
          `${CUSTOMER_API_URL}?action=getSubscriptions`,
          {},
          { headers: { Authorization: setting.token } }
        );

        const subscriptions = subscriptionsResponse.data.filter((subscription: Subscription) => subscription.status === 'ACTIVE');
        if (subscriptions.length === 0) return;

        const subscription = subscriptions[0] as Subscription;
        setSubscriptionContractId(subscription.subscriptionContractId);

        const paymentMethodResponse = await axios.post(
            `${CUSTOMER_API_URL}?action=getPaymentMethod`,
            {
              subscriptionContractId: subscription.subscriptionContractId,
            },
            { headers: { Authorization: setting.token } }
        );

        if (!paymentMethodResponse.data) return;

        setPaymentMethod({
          ...paymentMethodResponse.data,
        });
      } catch (e) {
        console.log(e);
      }
    })();
  }, [setPaymentMethod, setSubscriptionContractId, setting.token]);

  const update = (subscriptionContractId: string, success: () => void, failed?: (message: string) => void) => {
    (async () => {
      try {
        await axios.post(
          `${CUSTOMER_API_URL}?action=paymentMethodUpdate`,
          {
            subscriptionId: subscriptionContractId,
          },
          {
            headers: { Authorization: setting.token },
          }
        );

        success();
      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    update,
  };
};
